<template>
    <div>
      <b-progress :value="this.step" :max="this.NoOfSteps" variant="info"></b-progress>
      <component :is="stepComponent"/>
      <br/> 
      <b-row>
        <b-col><b-button variant="outline-dark" v-if="this.step>1" v-on:click="back">Back</b-button></b-col>
        <b-col> 
            <b-button variant="outline-info" v-if="this.allComplete == false" v-on:click="next">Next</b-button>
            <b-button variant="outline-success" v-if="this.allComplete == true" v-on:click="finishWizard">Submit</b-button>
        </b-col>
      </b-row>
    

    
    </div>
  </template>
  
  <script>
  export default {
    data(){
        return{
        NoOfSteps: 5,
        step: 1,
        allComplete: false,
        }
    },
    
    computed: {
      stepComponent() {
        this.step;
        return () => import(`@/components/StockComponents/StockScreen${this.step}.vue`);
      }
    },
    methods: {
      next() {
        if (this.step < this.NoOfSteps){
            this.step++;
        }
        else{
            return;
        }
        
      },
      back(){
        this.step--;
      },
      finishWizard(){
        alert("We are done, do stuff here");
        this.$emit("WizardComplete");
      }
    }
  };
  </script>